import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { translate } from './translateFunction'; // Import the translate function
import './UserRequest.css'; // CSS-Datei für den Ladebalken

const PasswordReset = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false); // Loading state
  const [success, setSuccess] = useState(false); // Erfolgsmeldung
  const [error, setError] = useState(''); // Fehlernachricht
  const [showProgressBar, setShowProgressBar] = useState(false);
  const navigate = useNavigate();

  // State for translations
  const [translations, setTranslations] = useState({
    resetPasswordTitle: '',
    emailLabel: '',
    emailPlaceholder: '',
    resetPasswordButton: '',
    backToLoginLink: '',
    successMessage: '',
    errorMessage: ''
  });

  // Load translations when the component mounts
  useEffect(() => {
    const loadTranslations = async () => {
      const resetPasswordTitle = await translate(150); // "Passwort zurücksetzen"
      const emailLabel = await translate(151); // "E-Mail Adresse"
      const emailPlaceholder = await translate(152); // "E-Mail Adresse"
      const resetPasswordButton = await translate(153); // "Passwort zurücksetzen"
      const backToLoginLink = await translate(154); // "Zurück zur Anmeldung"
      const successMessage = await translate(155); // "Passwort-Reset-Anfrage erfolgreich gesendet."
      const errorMessage = await translate(156); // "Fehler beim Senden der Anfrage."

      setTranslations({
        resetPasswordTitle,
        emailLabel,
        emailPlaceholder,
        resetPasswordButton,
        backToLoginLink,
        successMessage,
        errorMessage
      });
    };

    loadTranslations();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError('');
    setSuccess(false);
    setShowProgressBar(true);

    try {
      const response = await fetch('/api/password-reset/request-password-reset', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/login'); // Automatische Weiterleitung zur Login-Seite
        }, 3000);
      } else {
        const errorText = await response.text();
        console.error('Fehler:', errorText);
        setError(translations.errorMessage);
      }
    } catch (error) {
      console.error('Fehler beim Senden der Anfrage:', error);
      setError(translations.errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container mt-5">
      {showProgressBar && <div className="progress-bar"></div>}
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h1 className="card-title">{translations.resetPasswordTitle}</h1>
              {error && <div className="alert alert-danger">{error}</div>}
              {success ? (
                <div className="feedback-success-message" style={{ textAlign: 'center' }}>
                  <div className="checkmark">&#10003;</div>
                  <h3>{translations.successMessage}</h3>
                  <p>{translations.backToLoginLink}</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="email">{translations.emailLabel}</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder={translations.emailPlaceholder}
                      required
                      disabled={isSubmitting} // Disable input while submitting
                    />
                  </div>
                  <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                    {isSubmitting ? 'Sending...' : translations.resetPasswordButton}
                  </button>
                </form>
              )}
              {!success && (
                <div className="mt-3">
                  <Link to="/login">{translations.backToLoginLink}</Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
